module.exports = __webpack_public_path__ + "img/waistband partly elastic length.21c93067.png";